import styled, { css, keyframes } from "styled-components"
import { MdNotificationsActive } from "react-icons/md"
import { FaRegUser, FaCaretDown, FaCaretUp, FaUserPlus } from "react-icons/fa"
import { motion } from "framer-motion";
import { IoMdSettings } from "react-icons/io";
import { IoExitOutline } from "react-icons/io5";
import { TbBellExclamation } from "react-icons/tb";
import BellIcon from "../../components/icons/BellIcon";
import UserSolidIcon from "../../components/icons/UserSolidIcon";
import WalletIcon from "../../components/icons/WalletIcon";
import CaretUpIcon from "../../components/icons/CaretUpIcon";
import CaretDownIcon from "../../components/icons/CaretDownIcon";


const Body = styled.div`
  direction: ${props => props.theme.english ? 'ltr' : 'rtl'};
  display: flex;
  flex-direction: ${props => props.resp ? 'row' : 'column'};
  align-items: center;
  justify-content: space-between;
  border-radius: ${props => '16px'};
  height: 80px;
  width: ${"calc(100% - 38px)"};
  position: fixed;
    top: ${"55px"};
  left: 50%;
  transform: translateX(-50%);
    transition: all ease-in-out;
  transition-delay: 100ms;
  transition-duration: 200ms;
  z-index: 100;
  padding: 20px 24px;
  background-color: ${props => props.theme.cardBg};

  /* Default: only show border on large screens */
  border: 1px solid ${props => props.theme.purpleBorder};

  /* Remove border and show gradient ::after on small screens */
  @media screen and (max-width: 767px) {
    border: none;

    &::after {
      content: "";
      position: absolute;
      right: ${props => props.theme.english ? "0" : "50%"};
      left: ${props => props.theme.english ? "50%" : "0"};
      transform: ${props => props.theme.english ? "translateX(-50%)" : "translateX(50%)"};
      bottom: 0;
      width: 100%;
      max-width: 600px;
      z-index: 1;
      height: 2px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      background: linear-gradient(to right, #7F4FB200, #9F64DF, #7F4FB200);
    }
  }
`;


const HeaderMenuBody = styled(motion.div)`
  display: flex;
  align-items: center;
  position: relative;
  padding: 16px 55px;
  gap: 70px;

  @media screen and (max-width: 1024px) {
    gap: 35px;
  }

`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

const FlexColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`

const MLink = styled.div`
  color: ${props => props.theme.primary};
  margin: 0 20px;
  transition: all 0.3s;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover{
    color: ${props => props.theme.active};
  };

  @media screen and (max-width: 1050px){
    margin: 0 10px;
    font-size: 0.8rem;
  };

  @media screen and (max-width: 768px){
    margin: 0 10px;
    font-size: 0.7rem;
  };
`


const MText = styled.div`
  color: ${props => props.theme.textColor};
  transition: all 0.3s;
  font-size: ${props => props.fontSize || "0.8rem"};
  cursor: pointer;

  &:hover{
    color: ${props => props.theme.primaryOrange};
  }

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
`

const NotWrapper = styled.div`
  position: relative;
  margin: 0 15px;
`

const Notification = styled(BellIcon)`
  color: ${props => props.theme.iconColor};
  `

export const ProfileIcon = styled(UserSolidIcon)`
  color: ${props => props.theme.iconColor};
  `

export const WalletDropDownIcon = styled(WalletIcon)`
  color: ${props => props.theme.iconColor};
  `
export const CaretUp = styled(CaretUpIcon)`
  color: ${props => props.theme.iconColor};
`


export const CaretDown = styled(CaretDownIcon)`
  color: ${props => props.theme.iconColor};
`

export const SubHeaderToggler = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${(props) => props.theme.colorHeaderIcon};;

`

const Button = styled.div`
  background-color: ${props => props.theme.active};
  color: ${props => props.theme.bg};
  border-radius: 5px;
  width: 90px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 0.8rem;

  @media screen and (max-width: 768px){
    font-size: 0.7rem;
    width: 70px;
    height: 30px;
    margin: 0 8px;
  }
`

const Profile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${props => props.theme.color};
  cursor: pointer;

`

const Avatar = styled(FaRegUser)`
  color: ${props => props.theme.primaryOrange};
`

const DropBody = styled(motion.div)`
  position: absolute;
  min-width: ${props => props.minWidth};
  overflow: hidden;
  padding: 0.5rem 0;
  z-index: 100;
  background-color: ${props => props.theme.settingBg};
  border-radius: 12px;
  top: calc(100% + 5px);
  transition: all 0.3s;
  direction: ${props => props.theme.english ? "ltr" : "rtl"};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  max-height: calc(100vh - 13rem);
  min-height: max-content;

  overflow: auto;
  ${props => props.theme.english && css`
    right: 0;
  `};
  ${props => !props.theme.english && css`
    left: 0;
  `};

  /* Under 550px => CENTER IT */
  @media (max-width: 550px) {
    position: fixed;
    top: 65px;
    left: 50% !important;
    transform: translateX(-50%);
  }
  /* Under 420px => Full width */
  @media (max-width: 450px) {
    min-width: 100% !important;
  }

  &::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* Hide scrollbar for Firefox */
scrollbar-width: none;

/* Hide scrollbar for IE/Edge Legacy */
-ms-overflow-style: none;

`;


const DropItem = styled.div`
  min-width: 120px;
  cursor: pointer;
  margin: 4px 0;
  padding: 6px 0;
  transition: all 0.3s;
  position: relative;
  font-size: 0.8rem;
  color: ${(props) =>
    (props.active && props.theme.active) || props.theme.color};
  ${(props) =>
    props.active &&
    css`
            background-color: ${(props) => props.theme.hover};

            &::after {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              height: 100%;
              width: 8px;
              background-color: ${(props) => props.theme.color};
            }
          `}

  &:hover {
    background-color: ${(props) => props.theme.hover};
  }
`

const Balance = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.black};
  background-color: ${props => props.theme.active};
  padding: 8px 12px;
  margin: 2px 0 10px 0;
  /* letter-spacing: 1.2px; */
  font-weight: 600;
  border-radius: 8px;
  text-align: start;
  font-family: monospace !important;

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    /* letter-spacing: 1px; */
  }
`

const ProfileItem = styled.div`
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: ${props => props.theme.english ? "row" : "row-reverse"};
  padding: 16px 12px ;
  ${props => !props.last && css`
    border-bottom: 1px solid ${props => props.theme.primaryBg}80;
  `}
  transition: all 0.3s;

  &:hover{
    background-color: ${(props) => props.theme.hover};
    border-radius: 8px;
  }

  @media screen and (max-width: 480px) {
    padding: 8px;
  }

  &:nth-child(odd) {
		background-color: ${(props) => props.theme.secondaryBg};
	}
`

const Image = styled.img`
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 50%;
`

const NotItem = styled.div`
  border-radius: 8px;
  margin: 10px 0;
  padding: 8px 12px;
  background-color: ${props => props.theme.dropdown};
  color: ${props => props.theme.color};
  display: flex;
  align-items: center;
`

const NotText = styled.div`
  font-size: ${props => props.fontSize};
  color: ${props => props.color || props.theme.textColor};
`

const SettingWrapper = styled.div`
  width: 100%;
  margin: 10px 0;
  padding: 4px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${props => props.active && css`
    border-bottom: 1px solid ${props => props.theme.color}20;
  `}
`

const SettingItem = styled.div`
  color: ${props => props.theme.color};
  font-size: 0.7rem;
`

const SettingSub = styled.div`
  color: ${props => props.theme.color};
  font-size: 0.7rem;
  width: 100%;
`


const UpCaret = styled(FaCaretUp)`
  color: ${props => props.theme.color};
`

const DownCaret = styled(FaCaretDown)`
  color: ${props => props.theme.color};
`

const SettingCheckBox = styled.div`
  width: 12px;
  height: 12px;
  margin: 0 8px;
  position: relative;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
`

const InfiniteAnim = keyframes`
  0% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
`

const UnreadNotificationIcon = styled.div`
  width: 11px;
  height: 11px;
  background-color: ${props => props.theme.mainOrange};
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 50%;
  animation: ${InfiniteAnim} 1.5s infinite;

  @media screen and (max-width: 1050px) {
    width: 8px;
    height: 8px;
  }
`

const Menu = styled(motion.div)`
  position: absolute;
  padding: 20px 5px 10px 20px;
  background-color: ${props => props.theme.primaryBg};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid ${props => props.theme.color}20;
  left: -1px;
  top: 80px;
`

const LinkRow = styled(Flex)`
  color: ${props => props.theme.color};
  margin: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${props => props.theme.color}15;
`

const LayoutSettingIcon = styled(IoMdSettings)`
  color: ${props => props.theme.color};
  margin: 0 8px;
  cursor: pointer;

  &:hover{
    color: ${props => props.theme.mainOrange};
  };
`

const MHeaderIconWrapper = styled.div`
  padding: 0.7rem;
  margin: 0 5px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;

  &:hover {
    opacity: 70%;
  }

  /* Bottom gradient border */
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px; /* thickness of the border */
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: linear-gradient(to right, #7F4FB200, #9F64DF, #7F4FB200);
  }

  @media screen and (max-width: 768px) {
    padding: 0.6rem;
    margin: 0 2px;
  }
`;

const MHeaderButtonWrapper = styled(MHeaderIconWrapper)`
  background-color: ${props => props.theme.active};
  color: #191c20;
  font-size: 0.85rem;
  font-weight: 600;
  
  &:hover {
    background-color: ${(props) => props.theme.active};
  };

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  };
`

const RegisterIcon = styled(FaUserPlus)`
  color: ${props => props.theme.color};
  margin: 0 8px;
  margin-bottom:3px;
`

const SinginIcon = styled(IoExitOutline)`
  color: #191c20;
  margin: 0 8px;
  margin-bottom:3px;
`

export {
  NotText,
  NotItem,
  Image,
  Body,
  DropBody,
  DropItem,
  Flex,
  FlexColumn,
  Profile,
  ProfileItem,
  Balance,
  Notification,
  NotWrapper,
  Avatar,
  MText,
  MLink,
  Button,
  SettingWrapper,
  SettingItem,
  SettingSub,
  UpCaret,
  DownCaret,
  SettingCheckBox,
  UnreadNotificationIcon,
  Menu,
  LinkRow,
  LayoutSettingIcon,
  MHeaderIconWrapper,
  RegisterIcon,
  SinginIcon,
  MHeaderButtonWrapper,
  HeaderMenuBody
}
